import React, { useContext } from "react";
// room context
import { RoomContext } from "../../context/RoomContext";
// headless ui menu
import { Menu } from "@headlessui/react";
// icons
import { BsChevronDown } from "react-icons/bs";
import { FiUsers } from "react-icons/fi";

const lis = [
  { name: "2 Adultos" },
  { name: "3 Adultos" },
  { name: "4 Adultos" },
  { name: "5 Adultos" },
  { name: "6 Adultos" },
];

const AdultsDropdown = () => {
  const { adults, setAdults } = useContext(RoomContext);
  return (
    <Menu as="div" className="w-full h-full bg-white relative">
      {/* btn */}
      <Menu.Button className="w-full h-full flex items-center justify-between px-5">
        <span className="flex items-center gap-3 text-[15px]">
          <FiUsers className="text-accent text-base flex-shrink-0" />
          {adults}
        </span>
        <BsChevronDown className="text-base text-accent-hover" />
      </Menu.Button>
      {/* items */}
      <Menu.Items
        as="ul"
        className="bg-white absolute w-full flex flex-col z-40 shadow-xl"
      >
        {lis.map((li, index) => {
          return (
            <Menu.Item
              onClick={() => setAdults(li.name)}
              as="li"
              className="border-b last-of-type:border-b-0 h-12 hover:bg-accent hover:text-white w-full flex justify-center items-center cursor-pointer"
              key={index}
            >
              {li.name}
            </Menu.Item>
          );
        })}
      </Menu.Items>
    </Menu>
  );
};

export default AdultsDropdown;
